* {
  box-sizing: border-box;
}

:host {
  box-sizing: border-box;
  display: block;
  max-width: 100%;
}

:host(.last-group) {
  gz-collapsible-timeline-item:not([isOpen]):last-of-type::part(collapsible-panel)::after {
    content: none;
  }
}

gz-collapsible-timeline-item[isOpen] + gz-collapsible-timeline-item::part(collapsible-panel)::before {
  background-color: var(--blue-layout-300-active);
}
